import {ElMessage} from 'element-plus';

/**
 * 商品类型：1库存 2服务 3计次 4组合
 */
export const productTypeList = [
  {name: "库存商品", code: 1},
  {name: "服务商品", code: 2},
  {name: "计次商品", code: 3},
  {name: "组合商品", code: 4},
];

export default {
  /**
   * 属性集笛卡尔积，生成多规格 SKU 组合
   * 输入 [['S','M'],['黑','白']] → 输出 [['S','黑'],['S','白'],['M','黑'],['M','白']]
   */
  attributeGroups(attributes) {
    let arr = [[]];
    for (let i = 0; i < attributes.length; i++) {
      let item = attributes[i];
      let data = JSON.parse(JSON.stringify(arr));
      let dataResult = [];
      for (let j = 0; j < item.length; j++) {
        let itemArr = JSON.parse(JSON.stringify(data));
        for (let k = 0; k < itemArr.length; k++) {
          itemArr[k].push(item[j])
        }
        dataResult = dataResult.concat(itemArr);
      }
      arr = dataResult;
    }
    return arr;
  },

  /**
   * 根据属性集（attributeList）按笛卡尔积生成 SKU 列表
   * @param product 商品主信息
   * @param attributeList 属性集 [{attributeName, attributeValues: '["红","蓝"]'}]
   * @returns SKU 列表 [{skuName, skuCode, attributeInfo, attributeValues, status}]
   */
  generateSkuList(product, attributeList) {
    if (!attributeList || attributeList.length === 0) {
      return [];
    }
    // 解析每个属性的属性值数组
    let valueArrays = [];
    let nameArrays = [];
    for (let i = 0; i < attributeList.length; i++) {
      let attr = attributeList[i];
      let values = [];
      try {
        values = JSON.parse(attr.attributeValues || '[]');
      } catch (e) {
        values = [];
      }
      if (!Array.isArray(values)) {
        values = [attr.attributeValues];
      }
      valueArrays.push(values);
      nameArrays.push(attr.attributeName);
    }
    // 笛卡尔积
    let groups = this.attributeGroups(valueArrays);
    // 生成 SKU
    let skuList = [];
    for (let i = 0; i < groups.length; i++) {
      let group = groups[i];
      // 属性组合描述：如 红色/S
      let info = group.join('/');
      let attrInfoJson = [];
      for (let j = 0; j < nameArrays.length; j++) {
        attrInfoJson.push({name: nameArrays[j], value: group[j]});
      }
      skuList.push({
        productName: (product.productName || '') + info,
        attributeInfo: info,
        attributeValues: JSON.stringify(group), // 属性值JSON字符串
        buyPriceBase: '',
        salePriceBase: '',
        status: 1,
      });
    }
    return skuList;
  },

  /**
   * 保存前数据校验（字段与后端 ProductDomain 对齐）
   */
  checkData(data) {
    if (!data.productName) {
      ElMessage.error("请输入商品名称");
      throw new Error("请输入商品名称");
    }
    if (!data.productType) {
      ElMessage.error("请选择商品类型");
      throw new Error("请选择商品类型");
    }
    if (!data.unitIdBase) {
      ElMessage.error("请选择商品基本单位");
      throw new Error("请选择商品基本单位");
    }
    // 多规格 SKU 名称补全
    if (data.skuList) {
      for (let i = 0; i < data.skuList.length; i++) {
        if (!data.skuList[i].skuName) {
          data.skuList[i].skuName = data.productName + (data.skuList[i].attributeInfo || "");
        }
        // 属性集为空且手动添加的 SKU，补充 attributeValues
        if (!data.skuList[i].attributeValues) {
          data.skuList[i].attributeValues = JSON.stringify([data.skuList[i].attributeInfo || data.skuList[i].skuName]);
        }
      }
    }
  },

  /**
   * 详情标准化：编辑回显时处理
   */
  formatDetail(detail) {
    if (!detail) return detail;
    // 保证属性集和 SKU 列表存在
    if (!detail.attributeList) {
      detail.attributeList = [];
    }
    if (!detail.skuList) {
      detail.skuList = [];
    }
    // 属性集：确保 attributeValues 是数组或可解析，并生成编辑用的文本
    if (detail.attributeList) {
      for (let i = 0; i < detail.attributeList.length; i++) {
        if (detail.attributeList[i].attributeValues && typeof detail.attributeList[i].attributeValues === 'string') {
          try {
            detail.attributeList[i].attributeValuesJson = JSON.parse(detail.attributeList[i].attributeValues);
          } catch (e) {
            detail.attributeList[i].attributeValuesJson = [detail.attributeList[i].attributeValues];
          }
        } else {
          detail.attributeList[i].attributeValuesJson = [];
        }
        // 生成逗号分隔文本用于编辑
        if (detail.attributeList[i].attributeValuesJson) {
          detail.attributeList[i].attributeValuesText = detail.attributeList[i].attributeValuesJson.join(',');
        } else {
          detail.attributeList[i].attributeValuesText = '';
        }
      }
    }
    // SKU 列表：解析 attributeValues
    if (detail.skuList) {
      for (let i = 0; i < detail.skuList.length; i++) {
        if (detail.skuList[i].attributeValues && typeof detail.skuList[i].attributeValues === 'string') {
          try {
            detail.skuList[i].attributeValuesJson = JSON.parse(detail.skuList[i].attributeValues);
          } catch (e) {
            detail.skuList[i].attributeValuesJson = [detail.skuList[i].attributeValues];
          }
        }
      }
    }
    // 辅助信息：auxiliaryInfo JSON → auxiliaryList
    if (detail.auxiliaryInfo) {
      try {
        detail.auxiliaryList = JSON.parse(detail.auxiliaryInfo);
      } catch (e) {
        detail.auxiliaryList = [];
      }
    }
    if (!detail.auxiliaryList) {
      detail.auxiliaryList = [];
    }
    return detail;
  },
  //
  // /**
  //  * 列表标准化：显示名称映射
  //  */
  // formatList(list) {
  //   if (!list) return [];
  //   for (let i = 0; i < list.length; i++) {
  //     let it = list[i];
  //     // 商品类型名
  //     let type = productTypeList.find(t => t.code === it.productType);
  //     it.productTypeName = type ? type.name : it.productType;
  //     // 序列号名
  //     if (it.serialEnabled === 1) {
  //       it.serialEnabledName = it.serialRequired === 1 ? "严格" : "开启";
  //     } else {
  //       it.serialEnabledName = "关闭";
  //     }
  //   }
  //   return list;
  // },
};
